import angular from 'angular';
import _ from 'lodash-es';

angular.module('shbdeployer.app').controller('GroupsController', GroupsController);

function GroupsController($scope, $state, $async, GroupService, Notifications) {
  $scope.removeAction = removeAction;

  function removeAction(selectedItems) {
    return $async(removeActionAsync, selectedItems);
  }

  async function removeActionAsync(selectedItems) {
    for (let group of selectedItems) {
      try {
        await GroupService.deleteGroup(group.Id);

        Notifications.success('Готово', 'Группа окружений «' + group.Name + '» успешно удалена');
        _.remove($scope.groups, group);
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось удалить группу окружений');
      }
    }

    $state.reload();
  }

  function initView() {
    GroupService.groups()
      .then(function success(data) {
        $scope.groups = data;
      })
      .catch(function error(err) {
        Notifications.error('Ошибка', err, 'Не удалось получить список групп окружений');
        $scope.groups = [];
      });
  }

  initView();
}
